<template lang="pug">
  div
    slot(name='children'
        v-bind:parentContainer='outerContainer')

    slot(v-if='rendered',name='holder',
        v-bind:holder='holder',
        v-bind:transform='transform',
        v-bind:depth='depth',
        v-bind:innerContainer='innerContainer',
        v-bind:outerContainer='outerContainer',
        v-bind:displayObject='primitive.graphics')
</template>
<script>
import { makeShape } from '@/play/game/util.js';
import { flatten } from 'lodash';
import EventEmitter from 'eventemitter3';
export default {
  props:{
    transform: {
      type: Object,
      required: true
    },
    innerContainer: {
      type: Object,
      required: true
    },
    outerContainer: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    holder: {
      type: Object,
      required: true
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const primitive = new Primitive(this.renderTools, this.innerContainer, this.transform, component);
    return {
      primitive,
      component,
      rendered: false
    }
  },
  mounted() {
    this.primitive.events.on("loaded", () => {
      this.rendered = true;
      this.$emit("loaded");
    });
    this.renderTools.addToEnterBatch(this.primitive);
    this.renderTools.addToUpdateBatch(this.primitive);
  },
  watch:{
    'component.shapetype'() {
      this.renderTools.addToUpdateBatch(this.primitive);
    },
    'component.stroke'() {
      this.renderTools.addToUpdateBatch(this.primitive);
    },
    'component.color'() {
      this.renderTools.addToUpdateBatch(this.primitive);
    },
    'component.lineWidth'() {
      this.renderTools.addToUpdateBatch(this.primitive);
    },
    'component.scalex'() {
      this.renderTools.addToUpdateBatch(this.primitive);
    },
    'component.scaley'() {
      this.renderTools.addToUpdateBatch(this.primitive);
    }
  }
}

function makeColor(x) {
  if (!x) {
    return '0xffffff';
  }
  if (x.indexOf('#') === 0) {
    return x.replace('#', '0x')
  } else {
    return x;
  }
}

/*
function makeShape(themes, graphics, component, renderTools) {
  graphics.clear();
  let chosenTheme;
  if (component.theme && component.theme !== '') {
    for (let j = 0; j < (themes||[]).length; j++) {
      const theme = themes[j];
      if (theme.name === component.theme) {
        chosenTheme = theme;
      }
    }
  }
  if (component.shapetype === 'circle') {
    if (chosenTheme) {
      console.log('HAVE A THEME', chosenTheme);
      graphics.lineStyle(component.lineWidth, makeColor(chosenTheme.stroke));
      graphics.beginFill(makeColor(chosenTheme.fill));
    } else {
      if (component.stroke !== '') {
        graphics.lineStyle(component.lineWidth, component.stroke);
      }
      graphics.beginFill(makeColor(component.color))
    }
    const width = renderTools.worldToScreen_x(1);
    const height = renderTools.worldToScreen_y(1);
    graphics.drawEllipse(width/2, height/2, width/2, height/2);
    graphics.endFill()

  } else if (component.shapetype === 'custom') {
    const polygon = flatten(component.points.map( (p) => {
      return [p.x,p.y];
    }));
    graphics.beginFill(0xffff00);
    graphics.drawPolygon(polygon);
    graphics.endFill();
  } else {

    if (chosenTheme) {
      console.log('HAVE A THEME', chosenTheme);
      graphics.lineStyle(component.lineWidth, makeColor(chosenTheme.stroke));
      graphics.beginFill(makeColor(chosenTheme.fill));
    } else {
      console.log('stroke color is', component.stroke);
      console.log('stroke line width', component.lineWidth);
      if (component.stroke !== '') {
        graphics.lineStyle(component.lineWidth, component.stroke);
      }
      graphics.beginFill(makeColor(component.color))
    }


    const width = renderTools.worldToScreen_x(1);
    const height = renderTools.worldToScreen_y(1);
    graphics.drawRect(-width/2, -height/2, width, height);
    graphics.endFill();
  }

}
*/

function Primitive(renderTools, parentContainer, transform, data) {
  this.parentContainer = parentContainer;
  this.renderTools = renderTools;
  this.transform = transform;
  this.alpha = 1;
  this.events = new EventEmitter();
  this.loading = true;
  this.data = data;
  this.primitive = new PIXI.Graphics();
  this.themes = {};
}
Primitive.prototype.enter = function () {
  this.parentContainer.addChild(this.primitive);
  //this.primitive.scale.x = 40;
  //this.primitive.scale.y = 40;

  //console.log('MAKE SOME TEXT', this.data);
  //this.text = makeStyledText(this.themes, this.data.text, this.data);
  //this.textContainer.addChild(this.text);
  //this.text.anchor.x = 0.5;
  //this.text.anchor.y = 0.5;
  //this.text.scale.x = 40;
  //this.text.scale.y = 40;
}

Primitive.prototype.update = function () {
  makeShape(this.themes, this.primitive, this.data, this.renderTools);

  if (this.loading) {
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
    this.loading = false;
  }
}

Primitive.prototype.waiting = function () {
    this.events.emit("loaded");
}
Primitive.prototype.exit = function () {
  //this.editor.removeInteractive(this.myContainer);
  this.parentContainer.removeChild(this.primitive);
  this.primitive.destroy({
    texture:true,
    baseTexture:true
  });
}


</script>
